import { Control } from 'react-hook-form';
import { Checkbox } from '../../../../ui/components/ui/checkbox';
import { FormField, FormItem, FormMessage } from '../../../../ui/components/ui/form';
import { OfferAddOnOptionResponseDto } from '../../types/response';
import OfferFormSection, { CollapsiblePanelProps } from '../offer-form-section/offer-form-section';
import { OfferFormValues } from '../offer-form/offer-form.schema';

export interface OfferAddOnSectionProps {
  control: Control<OfferFormValues>;
  /** Active add-ons only. */
  addOns: OfferAddOnOptionResponseDto[];
  panel: CollapsiblePanelProps;
}

/** Add-ons are always included and taken over unchanged – they can only be picked. */
const OfferAddOnSection = ({ control, addOns, panel }: OfferAddOnSectionProps) => (
  <OfferFormSection title="Add-ons" description="Immer inklusive, werden unverändert übernommen." panel={panel}>
    {addOns.length === 0 ? (
      <p className="text-[14px] text-[#888]">Keine aktiven Add-ons vorhanden.</p>
    ) : (
      <FormField
        control={control}
        name="addOnIds"
        render={({ field }) => (
          <FormItem className="flex flex-col gap-3">
            {addOns.map((addOn) => {
              const isChecked = field.value.includes(addOn._id);
              return (
                <label key={addOn._id} className="flex items-start gap-3 cursor-pointer">
                  <Checkbox
                    className="mt-0.5"
                    checked={isChecked}
                    onCheckedChange={(checked) =>
                      field.onChange(checked ? [...field.value, addOn._id] : field.value.filter((id) => id !== addOn._id))
                    }
                  />
                  <span className="flex flex-col gap-0.5">
                    <span className="text-[14px] font-bold text-[#12282A]">{addOn.title}</span>
                    {addOn.description && <span className="text-[12px] text-[#888] whitespace-pre-line">{addOn.description}</span>}
                  </span>
                </label>
              );
            })}
            <FormMessage />
          </FormItem>
        )}
      />
    )}
  </OfferFormSection>
);

export default OfferAddOnSection;
